export interface IMobile {
  isMobileVersion: boolean;
}

export const DEFAULT_MOBILE: IMobile = {
  isMobileVersion: false,
};

export function mobileReducer(state: IMobile): IMobile {
  return state || DEFAULT_MOBILE;
}
